import {
  Button,
  MenuItem,
  Select,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import {GridAddIcon} from "@mui/x-data-grid-pro";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SendIcon from "@mui/icons-material/Send";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
  GridToolbarFilterButton,
} from "@mui/x-data-grid-pro";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import DeleteIcon from '@mui/icons-material/Delete';
import {useState} from "react";
import sendRequest from "../services/sendRequest";
import {useSnackbar} from "notistack";
import CloseIcon from '@mui/icons-material/Close';
import {IconButton} from '@mui/material';

const role = localStorage.getItem("role");
console.log("role---", role);

const CustomToolbar = ({
                         openEditDialogue,
                         setOpenReportGen,
                         bigQueryTable,
                         page,
                         selected,
                         open,
                         handleClickOpen,
                         handleQuickFilter,
                         targetValue,
                         setOpenUnknowAssetsUpload,
                         setOpenUnknownDealUpload,
                         setOpenExchangeRatesUpload,
                         setOpenDFPRatesUpload,
                         setOpenAssetsExport,
                         setOpenUnknownAssetsExport,
                         selectedRows,
                         setOpenUnknownProgrammeUpload,
                         setOpenDealExport,
                         setOpenAssetsDataExport,
                         setOpenAssetsDataUpload,
                         setOpenProgrammeExport,
                         setOpenUserDelete,
                         setOpenProgrammeDelete,
                         setDealType,
                         setProgrammeType,
                         setRefresh,
                       }) => {
  const {enqueueSnackbar, closeSnackbar} = useSnackbar()
  const [dealType, setLocalDealType] = useState("non-deleted");
  const [ProgrammeType, setLocalProgrammeType] = useState("non-deleted"); // State to track dropdown selection
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openConfirmDialogProgramme, setOpenConfirmDialogProgramme] = useState(false);// State for confirmation dialog
  const [openConfirmDialogResetReportGeneration, setOpenConfirmDialogResetReportGeneration] = useState(false);
  const handleDealTypeChange = (event) => {
    const selectedType = event.target.value;
    setLocalDealType(selectedType);
    setDealType(selectedType); // Update the state in DealsPage.jsx
    localStorage.setItem('selectedDealProgrammeType', selectedType);
    localStorage.setItem('selectedDeletedNonDeleted', "yes");
  };

  const handleProgrammeTypeChange = (event) => {
    const selectedType = event.target.value;
    setLocalProgrammeType(selectedType);
    localStorage.setItem('selectedDealProgrammeType', selectedType);
    setProgrammeType(selectedType); // Update the state in DealsPage.jsx
    localStorage.setItem('selectedDeletedNonDeleted', "yes");
  };

  const handleDealRevoke = async () => {
    console.log(selectedRows);

    try {
      // Extract all custom_id_stem values from selectedRows
      const custom_id_stem = selectedRows.map(row => row.custom_id_stem);
      localStorage.setItem('deal_revoke_list', custom_id_stem);
      // Call the API with the custom_id_stem list
      const response = await sendRequest({
        requestType: "put",
        endpoint: `deals/mark_deal_and_programme_as_revoked/`,
        requestData: {custom_id_stem: custom_id_stem}, // Pass the list of custom_id_stem
      });

      if (response.status === 200) {
        handleAllTypesOfMessages("The deals and associated programs have been successfully revoked!", "success");
      }

      if (page === "deals") {
        const auditPageJson = {
          custom_id_stem: custom_id_stem,
          table: page,
          user: localStorage.getItem('username'),
          action: "Revoke",
          changes: [],
          entity_id: localStorage.getItem('entity_id')
        };
        const auditPageResponse = await sendRequest({
          requestType: "put",
          endpoint: `${page}/create_audit_logs_deal_and_programme_revoke/`,
          requestData: auditPageJson,
        });
        console.log("Audit Page Response ", auditPageResponse)
      }
      const selectedType = "non-deleted";
      setLocalDealType(selectedType);
      setDealType(selectedType);
      localStorage.setItem('selectedDeletedNonDeleted', "no");
      localStorage.setItem('deal_revoke', "yes");
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  //rep
  const handleResetReportGenerationProcess = async () => {
    try {
      // Call the API with the custom_id list
      const response = await sendRequest({
        requestType: "put",
        endpoint: `${page}/reset_report_generation_process/`,
      });

      if (response.status === 200) {
        handleAllTypesOfMessages("All The Deals have been successfully reseted for report generation process!", "success");
        if (typeof triggerRefresh === "function") {
          triggerRefresh(); // call the wrapper
        } else {
          console.warn("triggerRefresh is not a function in CustomToolbar:", triggerRefresh);
        }
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const triggerRefresh = () => {
    console.log("triggerRefresh called in ManagePage");
    setRefresh((old) => !old);
  };

  const handleRevokeProgramme = async () => {
    console.log(selectedRows);

    try {
      // Extract all custom_id values from selectedRows
      const custom_id = selectedRows.map(row => row.custom_id);
      localStorage.setItem('programme_revoke_list', custom_id);

      // Call the API with the custom_id list
      const response = await sendRequest({
        requestType: "put",
        endpoint: `${page}/mark_programme_as_revoked/`,
        requestData: {custom_id: custom_id}, // Pass the list of custom_id
      });

      if (response.status === 200) {
        handleAllTypesOfMessages("The Programs have been successfully revoked!", "success");

        if (page === "programmes") {
          const auditPageJson = {
            custom_id: custom_id,
            table: page,
            user: localStorage.getItem('username'),
            action: "Revoke",
            changes: [],
            entity_id: localStorage.getItem('entity_id')
          };
          const auditPageResponse = await sendRequest({
            custom_id: custom_id,
            requestType: "put",
            endpoint: `${page}/create_audit_logs_programme_revoke/`,
            requestData: auditPageJson,
          });
          console.log("Audit Page Response ", auditPageResponse)
        }
        const selectedType = "non-deleted";
        setLocalProgrammeType(selectedType);
        localStorage.setItem('selectedDealProgrammeType', "no");
        setProgrammeType(selectedType); // Update the state in DealsPage.jsx
        localStorage.setItem('programme_revoke', "yes");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleOpenConfirmDialog = () => {
    setOpenConfirmDialog(true); // Open the confirmation dialog
  };

  //rep
  const handleOpenConfirmResetReportGeneration = () => {
    setOpenConfirmDialogResetReportGeneration(true); // Open the confirmation dialog
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false); // Close the confirmation dialog
  };

  const handleConfirmRevoke = () => {
    handleDealRevoke(); // Call the revoke function
    setOpenConfirmDialog(false); // Close the dialog after confirming
  };

  const handleOpenConfirmDialogProgramme = () => {
    setOpenConfirmDialogProgramme(true); // Open the confirmation dialog
  };
  const handleCloseConfirmDialogProgramme = () => {
    setOpenConfirmDialogProgramme(false); // Close the confirmation dialog
  };

  //rep
  const handleCloseConfirmDialogResetReportGeneration = () => {
    setOpenConfirmDialogResetReportGeneration(false); // Close the confirmation dialog
  };

  const handleConfirmRevokeProgramme = () => {
    handleRevokeProgramme(); // Call the revoke function
    setOpenConfirmDialogProgramme(false); // Close the dialog after confirming
  };

  //rep
  const handleConfirmResetReportGeneration = () => {
    handleResetReportGenerationProcess(); // Call the revoke function
    setOpenConfirmDialogResetReportGeneration(false); // Close the dialog after confirming
  };


  //handleAllTypesOfMessages
  // const handleAllTypesOfMessages = (message, type) => {
  //   enqueueSnackbar(message, {
  //     variant: type,
  //   });
  // };

  //handleAllTypesOfMessages
  const handleAllTypesOfMessages = (message, type) => {
    const action = (key) => (
      <IconButton
        aria-label="close"
        color="inherit"
        onClick={() => closeSnackbar(key)}
      >
        <CloseIcon/>
      </IconButton>
    );

    enqueueSnackbar(message, {
      variant: type,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      persist: true, // <- keeps the snackbar visible until manually closed
      // autoHideDuration: 20000,
      action
    });
  };


  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton/>
      <GridToolbarDensitySelector/>
      {!bigQueryTable && page !== "reports" && page !== "job" && role === 'full access' && (
        <Button
          startIcon={<GridAddIcon/>}
          onClick={() => openEditDialogue("add")}
        >
          Add New
        </Button>
      )}
      <GridToolbarFilterButton
        nonce={""}
        onResize={() => null}
        onResizeCapture={() => null}
        componentsProps={{
          button: {
            //disabled: loading,
          },
        }}
      />
      {page === "reports" && role === 'full access' && (
        <Button
          onClick={() => handleClickOpen()}
          startIcon={<SendIcon/>}
          disabled={selected.length < 1}
        >
          Email Report
        </Button>
      )}
      {page === "deals" && role === 'full access' && (
        <>
          {/* Dropdown for Deal Type */}
          <Select
            value={dealType}
            onChange={handleDealTypeChange}
            displayEmpty
            style={{marginRight: "10px"}}
          >
            <MenuItem value="non-deleted">Active Deals</MenuItem>
            <MenuItem value="deleted">Archived Deals</MenuItem>
          </Select>

          {/* Buttons based on dropdown selection */}
          {dealType === "non-deleted" && (
            <>
              <Button
                onClick={() => setOpenReportGen(true)}
                startIcon={<AssessmentIcon/>}
                disabled={selected.length < 1}
              >
                Generate Reports
              </Button>
              <Button
                onClick={() => setOpenUnknownDealUpload(true)}
                startIcon={<CloudUploadIcon/>}
              >
                Upload CSV
              </Button>
              <Button
                onClick={() => setOpenDealExport(true)}
                startIcon={<CloudDownloadIcon/>}
                disabled={selectedRows.length < 1}
              >
                Export
              </Button>
              {
                <Button
                  onClick={() => handleOpenConfirmResetReportGeneration(true)}
                  startIcon={<CloudDownloadIcon/>}>
                  Session Reset
                </Button>
              }
            </>
          )}
          {dealType === "deleted" && (
            <>
              <Button
                onClick={() => setOpenDealExport(true)}
                startIcon={<CloudDownloadIcon/>}
                disabled={selectedRows.length < 1}
              >
                Export
              </Button>
              <Button
                onClick={() => handleOpenConfirmDialog()}
                startIcon={<DeleteIcon/>}
                disabled={selectedRows.length < 1}
              >
                Revoke
              </Button>
            </>
          )}
        </>
      )}

      {page === "programmes" && role === "full access" && (
        <>
          {/* Dropdown for Deal Type */}
          <Select
            value={ProgrammeType}
            onChange={handleProgrammeTypeChange}
            displayEmpty
            style={{marginRight: "10px"}}
          >
            <MenuItem value="non-deleted">Active Programmes</MenuItem>
            <MenuItem value="deleted">Archived Programmes</MenuItem>
          </Select>

          {/* Buttons based on dropdown selection */}
          {ProgrammeType === "non-deleted" && (
            <>
              <Button
                onClick={() => setOpenUnknownProgrammeUpload(true)}
                startIcon={<CloudUploadIcon/>}
              >
                Upload CSV
              </Button>
              <Button
                onClick={() => setOpenProgrammeExport(true)}
                startIcon={<CloudDownloadIcon/>}
                disabled={selectedRows.length < 1}
              >
                Export
              </Button>
            </>
          )}
          {ProgrammeType === "deleted" && (
            <Button
              onClick={() => handleOpenConfirmDialogProgramme()}
              startIcon={<DeleteIcon/>}
              disabled={selectedRows.length < 1}
            >
              Revoke
            </Button>
          )}
        </>
      )}
      {/* Confirmation Dialog */}
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
      >
        <DialogTitle>Confirm Revoke</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to revoke the selected deals?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmDialog} color="primary">
            Cancel
          </Button>
          <Button value={dealType} onClick={handleConfirmRevoke} color="secondary">
            Yes, Revoke
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmDialogProgramme}
        onClose={handleCloseConfirmDialogProgramme}
      >
        <DialogTitle>Confirm Revoke</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to revoke the selected Programme?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmDialogProgramme} color="primary">
            Cancel
          </Button>
          <Button value={ProgrammeType} onClick={handleConfirmRevokeProgramme} color="secondary">
            Yes, Revoke
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmDialogResetReportGeneration}
        onClose={handleCloseConfirmDialogResetReportGeneration}
      >
        <DialogTitle>Reset session report generation process</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to reset the data in the "session report generation" column and "session report date"
            column? This will not delete any reports which have already run
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmDialogResetReportGeneration} color="secondary">
            Cancel
          </Button>
          <Button value={ProgrammeType} onClick={handleConfirmResetReportGeneration} color="primary">
            Yes, Reset
          </Button>
        </DialogActions>
      </Dialog>
      {page === "assets" && role === "full access" && (
        <Button
          onClick={() => setOpenUnknowAssetsUpload(true)}
          startIcon={<CloudUploadIcon/>}
        >
          Upload CSV
        </Button>
      )}
      {page === "exchange_rates" && role === 'full access' && (
        <Button
          onClick={() => setOpenExchangeRatesUpload(true)}
          startIcon={<CloudUploadIcon/>}
        >
          Upload CSV
        </Button>
      )}
      {page === "dfp_rates" && role === "full access" && (
        <Button
          onClick={() => setOpenDFPRatesUpload(true)}
          startIcon={<CloudUploadIcon/>}
        >
          Upload CSV
        </Button>
      )}

      {page === "assets" && role === "full access" && (
        <Button
          onClick={() => setOpenAssetsExport(true)}
          startIcon={<CloudDownloadIcon/>}
          disabled={selectedRows.length < 1}
        >
          Export
        </Button>
      )}
      {page === "customIdsPerChannel" && role === "full access" && (
        <Button
          onClick={() => setOpenAssetsDataExport(true)}
          startIcon={<CloudDownloadIcon/>}
          disabled={selectedRows.length < 1}
        >
          Export
        </Button>
      )}
      {page === "customIdsPerChannel" && role === "full access" && (
        <Button
          onClick={() => setOpenAssetsDataUpload(true)}
          startIcon={<CloudUploadIcon/>}
          disabled={selectedRows.length < 1}
        >
          Upload
        </Button>
      )}
      {page === "users" && role === "full access" && (
        <Button
          onClick={() => setOpenUserDelete(true)}
          startIcon={<DeleteIcon/>}
          disabled={selectedRows.length < 1}
        >
          Delete
        </Button>
      )}
      {page === "unknown_assets" && role === "full access" && (
        <Button
          onClick={() => setOpenUnknownAssetsExport(true)}
          startIcon={<CloudDownloadIcon/>}
          disabled={selectedRows.length < 1}
        >
          Export
        </Button>
      )}
      {page === "assets" ? (
        <GridToolbarQuickFilter
          sx={{marginLeft: "auto"}}
          debounceMs={500}
          onChange={handleQuickFilter}
          value={targetValue}
        />
      ) : (
        <GridToolbarQuickFilter sx={{marginLeft: "auto"}} debounceMs={500}/>
      )}
    </GridToolbarContainer>
  );
};

export default CustomToolbar;
